var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ModalFullScreen", {
    attrs: { size: "lg" },
    on: { close: _vm.closeModal },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("span", { staticClass: "font-semibold text-base" }, [
              _vm._v("Add info to resource"),
            ]),
            _c(
              "button",
              {
                staticClass:
                  "cursor-pointer flex items-center justify-center absolute top-4 right-7",
                on: {
                  click: _vm.closeModal,
                  mouseover: function ($event) {
                    _vm.isHovered = true
                  },
                  mouseout: function ($event) {
                    _vm.isHovered = false
                  },
                },
              },
              [
                !_vm.isHovered
                  ? _c("CrossIcon", { staticClass: "h-3.5 w-3.5" })
                  : _vm._e(),
                _vm.isHovered
                  ? _c("CrossIconHover", { staticClass: "close-icon" })
                  : _vm._e(),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "ModalContent",
              { staticClass: "relative" },
              [
                _c(
                  "LoadingOverlay",
                  { attrs: { loading: _vm.loading, hasData: true } },
                  [
                    _vm.managementAddedInfoMode.skills
                      ? _c(
                          "div",
                          [
                            _c(
                              "FormGroup",
                              {
                                attrs: {
                                  title: "Skills (50 Max)",
                                  inputClass: "fullwidthInput",
                                },
                              },
                              [
                                _c("SkillsMultiselect", {
                                  attrs: {
                                    max: 50,
                                    getParentStyle: "customWidthInput",
                                  },
                                  model: {
                                    value: _vm.skillsIds,
                                    callback: function ($$v) {
                                      _vm.skillsIds = $$v
                                    },
                                    expression: "skillsIds",
                                  },
                                }),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex justify-end mt-2 pt-3 gap-2",
                                  },
                                  [
                                    _c("UIButton", {
                                      attrs: {
                                        buttonText: "Cancel",
                                        size: "lg",
                                        variant: "outline",
                                        processing: _vm.processing,
                                      },
                                      on: { click: _vm.closeModal },
                                    }),
                                    _c("UIButton", {
                                      attrs: {
                                        buttonText: _vm.skillsIds
                                          ? "Save"
                                          : "Add",
                                        size: "lg",
                                        variant: "black",
                                        processing: _vm.processing,
                                        disabled: !_vm.skillsIds.length,
                                      },
                                      on: {
                                        click: () => {
                                          _vm.upsertSkills()
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.managementAddedInfoMode.languages
                      ? _c(
                          "div",
                          [
                            _c(
                              "FormGroup",
                              {
                                staticClass: "mt-2",
                                attrs: { title: "Languages (5 Max)" },
                              },
                              [
                                _c("LanguagesMultiselect", {
                                  attrs: { max: 5 },
                                  model: {
                                    value: _vm.languages,
                                    callback: function ($$v) {
                                      _vm.languages = $$v
                                    },
                                    expression: "languages",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "flex justify-end mt-2 pt-3 gap-2",
                                attrs: { id: "morelanguagesmsg" },
                              },
                              [
                                _c("UIButton", {
                                  attrs: {
                                    buttonText: "Cancel",
                                    size: "lg",
                                    variant: "outline",
                                    processing: _vm.processing,
                                  },
                                  on: { click: _vm.closeModal },
                                }),
                                _c("UIButton", {
                                  attrs: {
                                    buttonText: _vm.languages ? "Save" : "Add",
                                    size: "lg",
                                    variant: "black",
                                    processing: _vm.processing,
                                    disabled: !_vm.languages.length,
                                  },
                                  on: {
                                    click: () => {
                                      _vm.upsertLanguages()
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.managementAddedInfoMode.experience
                      ? _c(
                          "div",
                          { staticClass: "mt-2" },
                          [
                            !_vm.showExperienceForm
                              ? _c("UIButton", {
                                  staticClass: "flex justify-end mb-4",
                                  attrs: {
                                    icon: "plus",
                                    buttonText: "Add experience",
                                    variant: "black",
                                    id: "experienceslot",
                                  },
                                  on: {
                                    click: () => {
                                      _vm.showExperienceForm = true
                                    },
                                  },
                                })
                              : _vm._e(),
                            _c("ExperienceForm", {
                              attrs: {
                                userId: _vm.userId,
                                currentUserId: _vm.currentUser.id,
                              },
                              on: {
                                added: () => {
                                  _vm.closeModalAndRefreshContractor()
                                },
                              },
                              model: {
                                value: _vm.showExperienceForm,
                                callback: function ($$v) {
                                  _vm.showExperienceForm = $$v
                                },
                                expression: "showExperienceForm",
                              },
                            }),
                            _vm._l(
                              _vm.experiencesByManagement,
                              function (experience) {
                                return _c("ExperienceCard", {
                                  key: experience.id,
                                  staticClass: "mt-4",
                                  attrs: {
                                    experience: experience,
                                    userId: _vm.userId,
                                    currentUserId: _vm.currentUser.id,
                                  },
                                  on: {
                                    updated: () => {
                                      _vm.closeModalAndRefreshContractor()
                                    },
                                    removed: () => {
                                      _vm.closeModalAndRefreshContractor()
                                    },
                                  },
                                })
                              }
                            ),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm.managementAddedInfoMode.education
                      ? _c(
                          "div",
                          { staticClass: "mt-2" },
                          [
                            !_vm.showEducationForm
                              ? _c("UIButton", {
                                  staticClass: "flex justify-end mb-4",
                                  attrs: {
                                    icon: "plus",
                                    id: "educationslot",
                                    buttonText: "Add education",
                                    variant: "black",
                                  },
                                  on: {
                                    click: () => {
                                      _vm.showEducationForm = true
                                    },
                                  },
                                })
                              : _vm._e(),
                            _c("EducationForm", {
                              attrs: {
                                education: _vm.educationsByManagement,
                                userId: _vm.userId,
                                currentUserId: _vm.currentUser.id,
                              },
                              on: {
                                added: () => {
                                  _vm.closeModalAndRefreshContractor()
                                },
                              },
                              model: {
                                value: _vm.showEducationForm,
                                callback: function ($$v) {
                                  _vm.showEducationForm = $$v
                                },
                                expression: "showEducationForm",
                              },
                            }),
                            _vm._l(
                              _vm.educationsByManagement,
                              function (education) {
                                return _c("EducationCard", {
                                  key: education.id,
                                  staticClass: "mt-4",
                                  attrs: {
                                    education: education,
                                    userId: _vm.userId,
                                    currentUserId: _vm.currentUser.id,
                                  },
                                  on: {
                                    updated: () => {
                                      _vm.closeModalAndRefreshContractor()
                                    },
                                    removed: () => {
                                      _vm.closeModalAndRefreshContractor()
                                    },
                                  },
                                })
                              }
                            ),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm.managementAddedInfoMode.email
                      ? _c("div", { attrs: { id: "contactinfoslot" } }, [
                          _c(
                            "div",
                            { staticClass: "mt-5" },
                            [
                              _c("ValidationProvider", {
                                attrs: {
                                  name: "Email Address",
                                  rules: "email",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ errors }) {
                                        return [
                                          _c("FormGroup", {
                                            staticClass: "mt-6",
                                            attrs: {
                                              name: "email",
                                              title: "",
                                              type: "search",
                                              placeholder: "Enter email",
                                              errors: errors,
                                              inputClass: "fullwidthInput",
                                              isIcon: false,
                                            },
                                            on: {
                                              hasErrors: (hasErrors) => {
                                                _vm.emailHasErrors = hasErrors
                                              },
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "title",
                                                  fn: function () {
                                                    return [
                                                      _c(
                                                        "p",
                                                        { staticClass: "mb-2" },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "required-icon",
                                                            },
                                                            [_vm._v("*")]
                                                          ),
                                                          _vm._v(
                                                            "Email Address "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                                {
                                                  key: "action",
                                                  fn: function () {
                                                    return [
                                                      _c(
                                                        "button",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              !_vm.email,
                                                          },
                                                          on: {
                                                            click: () => {
                                                              _vm.removeEmails()
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("DeleteGray", {
                                                            staticClass:
                                                              "w-4 h-4",
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                            model: {
                                              value: _vm.email,
                                              callback: function ($$v) {
                                                _vm.email = $$v
                                              },
                                              expression: "email",
                                            },
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  417690576
                                ),
                              }),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex justify-end mt-2 pt-3 gap-4",
                                },
                                [
                                  _c("UIButton", {
                                    attrs: {
                                      buttonText: "Cancel",
                                      size: "lg",
                                      variant: "outline",
                                      processing: _vm.processing,
                                    },
                                    on: { click: _vm.closeModal },
                                  }),
                                  _c("UIButton", {
                                    attrs: {
                                      buttonText: _vm.email ? "Save" : "Add",
                                      size: "lg",
                                      variant: "black",
                                      processing: _vm.processing,
                                      disabled:
                                        !_vm.email || _vm.emailHasErrors,
                                    },
                                    on: {
                                      click: () => {
                                        _vm.upsertProfileByManagement()
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm.managementAddedInfoMode.phone
                      ? _c("div", { attrs: { id: "contactinfoslot" } }, [
                          _c(
                            "div",
                            { staticClass: "mt-5" },
                            [
                              _c("ValidationProvider", {
                                attrs: {
                                  name: "Phone number",
                                  rules: {
                                    phoneNumberLength: [
                                      _vm.phone
                                        ? _vm.phone.toString().length
                                        : 0,
                                    ],
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ errors }) {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex flex-row gap-2",
                                            },
                                            [
                                              _c(
                                                "FormGroup",
                                                {
                                                  staticClass: "flex-1",
                                                  attrs: {
                                                    title: "",
                                                    type: "search",
                                                    errors: _vm.phoneTouched
                                                      ? errors
                                                      : [],
                                                    isIcon: false,
                                                    inputClass:
                                                      "fullwidthInput",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "title",
                                                        fn: function () {
                                                          return [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "mb-2",
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "required-icon",
                                                                  },
                                                                  [_vm._v("*")]
                                                                ),
                                                                _vm._v(
                                                                  "Phone number "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        },
                                                        proxy: true,
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                },
                                                [
                                                  _c("MaskedPhoneInput", {
                                                    attrs: {
                                                      invalid: Boolean(
                                                        _vm.phoneTouched &&
                                                          errors.length
                                                      ),
                                                    },
                                                    on: {
                                                      touched: () => {
                                                        _vm.phoneHasErrors =
                                                          !!errors.length
                                                        _vm.phoneTouched = true
                                                      },
                                                    },
                                                    model: {
                                                      value: _vm.phone,
                                                      callback: function ($$v) {
                                                        _vm.phone = $$v
                                                      },
                                                      expression: "phone",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "button",
                                                {
                                                  attrs: {
                                                    disabled: !_vm.phone,
                                                  },
                                                  on: {
                                                    click: () => {
                                                      _vm.removePhoneNumbers()
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("DeleteGray", {
                                                    staticClass: "w-4 h-4 mt-6",
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1552883839
                                ),
                              }),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex justify-end mt-2 pt-3 gap-4",
                                },
                                [
                                  _c("UIButton", {
                                    attrs: {
                                      buttonText: "Cancel",
                                      size: "lg",
                                      variant: "outline",
                                      processing: _vm.processing,
                                    },
                                    on: { click: _vm.closeModal },
                                  }),
                                  _c("UIButton", {
                                    attrs: {
                                      buttonText: _vm.phone ? "Save" : "Add",
                                      size: "lg",
                                      variant: "black",
                                      processing: _vm.processing,
                                      disabled:
                                        !_vm.phone || _vm.phoneHasErrors,
                                    },
                                    on: {
                                      click: () => {
                                        _vm.upsertProfileByManagement()
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm.managementAddedInfoMode.website
                      ? _c("div", { attrs: { id: "websiteslot" } }, [
                          _c(
                            "div",
                            { staticClass: "mt-5" },
                            [
                              _c("ValidationProvider", {
                                attrs: { rules: "url" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ errors }) {
                                        return [
                                          _c("FormGroup", {
                                            staticClass: "mt-6",
                                            attrs: {
                                              name: "website",
                                              title: "",
                                              type: "search",
                                              placeholder: "URL here",
                                              errors: errors,
                                              inputClass: "fullwidthInput",
                                              isIcon: false,
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "title",
                                                  fn: function () {
                                                    return [
                                                      _c(
                                                        "p",
                                                        { staticClass: "mb-2" },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "required-icon",
                                                            },
                                                            [_vm._v("*")]
                                                          ),
                                                          _vm._v(
                                                            "Website URL "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                                {
                                                  key: "action",
                                                  fn: function () {
                                                    return [
                                                      _c(
                                                        "button",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              !_vm.website,
                                                          },
                                                          on: {
                                                            click: () => {
                                                              _vm.removeWebsites()
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("DeleteGray", {
                                                            staticClass:
                                                              "w-4 h-4",
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                            model: {
                                              value: _vm.website,
                                              callback: function ($$v) {
                                                _vm.website = $$v
                                              },
                                              expression: "website",
                                            },
                                          }),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex justify-end mt-2 pt-3 gap-4",
                                            },
                                            [
                                              _c("UIButton", {
                                                attrs: {
                                                  buttonText: "Cancel",
                                                  size: "lg",
                                                  variant: "outline",
                                                  processing: _vm.processing,
                                                },
                                                on: { click: _vm.closeModal },
                                              }),
                                              _c("UIButton", {
                                                attrs: {
                                                  buttonText: _vm.website
                                                    ? "Save"
                                                    : "Add",
                                                  size: "lg",
                                                  variant: "black",
                                                  processing: _vm.processing,
                                                  disabled:
                                                    !_vm.website ||
                                                    !!errors.length,
                                                },
                                                on: {
                                                  click: () => {
                                                    _vm.upsertProfileByManagement()
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3735554330
                                ),
                              }),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm.managementAddedInfoMode.city
                      ? _c(
                          "div",
                          [
                            _c(
                              "FormWrapper",
                              {
                                attrs: {
                                  title: "About resource",
                                  body: "Provide information about the resource",
                                  styleClass:
                                    "border-textTertiary border rounded-lg",
                                },
                              },
                              [
                                _c("ValidationObserver", [
                                  _c(
                                    "form",
                                    [
                                      _c("ValidationProvider", {
                                        attrs: {
                                          name: "Country",
                                          rules: "required",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({ errors }) {
                                                return [
                                                  _c(
                                                    "FormGroup",
                                                    {
                                                      attrs: {
                                                        title: "Country*",
                                                        errors: errors,
                                                      },
                                                      on: {
                                                        hasErrors: (
                                                          hasErrors
                                                        ) => {
                                                          _vm.countryHasErrors =
                                                            hasErrors
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "ProfileCountrySelect",
                                                        {
                                                          model: {
                                                            value: _vm.country,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.country = $$v
                                                            },
                                                            expression:
                                                              "country",
                                                          },
                                                        }
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          467221169
                                        ),
                                      }),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex w-full justify-between",
                                        },
                                        [
                                          _c("ValidationProvider", {
                                            staticClass: "mr-2 flex-1",
                                            attrs: { name: "State" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({ errors }) {
                                                    return [
                                                      _c("RegionInput", {
                                                        attrs: {
                                                          countries:
                                                            _vm.country,
                                                          errors: errors,
                                                        },
                                                        model: {
                                                          value: _vm.state,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.state = $$v
                                                          },
                                                          expression: "state",
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              3875228843
                                            ),
                                          }),
                                          _c("FormGroup", {
                                            staticClass: "flex-1",
                                            attrs: {
                                              name: "postal_code",
                                              title: "Postal / Zip Code",
                                              placeholder:
                                                "Enter postal / zip code",
                                            },
                                            model: {
                                              value: _vm.postal_code,
                                              callback: function ($$v) {
                                                _vm.postal_code = $$v
                                              },
                                              expression: "postal_code",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c("ValidationProvider", {
                                        attrs: {
                                          name: "City",
                                          rules: "name_with_specific_symbols",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({ errors }) {
                                                return [
                                                  _c("FormGroup", {
                                                    attrs: {
                                                      title: "City",
                                                      placeholder: "Enter city",
                                                      errors: errors,
                                                    },
                                                    on: {
                                                      hasErrors: (
                                                        hasErrors
                                                      ) => {
                                                        _vm.cityHasErrors =
                                                          hasErrors
                                                      },
                                                    },
                                                    model: {
                                                      value: _vm.city,
                                                      callback: function ($$v) {
                                                        _vm.city =
                                                          typeof $$v ===
                                                          "string"
                                                            ? $$v.trim()
                                                            : $$v
                                                      },
                                                      expression: "city",
                                                    },
                                                  }),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          3093150553
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                ]),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex justify-end mt-2 pt-3 gap-2",
                                  },
                                  [
                                    _c("UIButton", {
                                      attrs: {
                                        buttonText: "Cancel",
                                        size: "lg",
                                        variant: "outline",
                                        processing: _vm.processing,
                                      },
                                      on: { click: _vm.closeModal },
                                    }),
                                    _c("UIButton", {
                                      attrs: {
                                        buttonText:
                                          _vm.country ||
                                          _vm.city ||
                                          _vm.postal_code ||
                                          _vm.state
                                            ? "Save"
                                            : "Add",
                                        size: "lg",
                                        variant: "black",
                                        processing: _vm.processing,
                                        disabled:
                                          !_vm.country.length ||
                                          (!_vm.state &&
                                            !_vm.postal_code &&
                                            !_vm.city) ||
                                          _vm.countryHasErrors ||
                                          _vm.cityHasErrors,
                                      },
                                      on: {
                                        click: () => {
                                          _vm.upsertProfileByManagement()
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.managementAddedInfoMode.resume
                      ? _c("div", [_vm._v("Resume")])
                      : _vm._e(),
                  ]
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [_c("p", [_vm._v("Buttons")])]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }